module.exports = __webpack_public_path__ + "img/email.f9a8c911.png";